function ssnValidator({ input, msgs }) {
  const rule = /^(?!000)\d{3}-?(?!00)\d{2}-?(?!0000)\d{4}$/;

  if (!rule.test(input)) {
    return (msgs && msgs.msg) || 'value must be a 9-digit number.';
  }

  return null;
}

export default ssnValidator;
